module.exports = __webpack_public_path__ + "img/manageModelImg2.e51a0a6b.png";